var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 20.5,
    r: 1.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 20.5,
    r: 1.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70091 2.73312C3.55351 2.34601 3.12022 2.1517 2.73312 2.29909C2.34601 2.44649 2.1517 2.87978 2.29909 3.26688L3.70091 2.73312ZM20.7863 6.58689L21.4993 6.81954L20.7863 6.58689ZM17.4102 14.3611L17.2821 13.6221L17.4102 14.3611ZM18.5801 13.3484L19.2931 13.581L18.5801 13.3484ZM9.168 15.789L9.03997 15.05L9.168 15.789ZM7.51012 14.8448L6.80922 15.1117L7.51012 14.8448ZM9.29603 16.528L17.5382 15.1L17.2821 13.6221L9.03997 15.05L9.29603 16.528ZM19.2931 13.581L21.4993 6.81954L20.0732 6.35425L17.8671 13.1157L19.2931 13.581ZM20.3109 5.1818H4.11634V6.6818H20.3109V5.1818ZM2.29909 3.26688L6.80922 15.1117L8.21103 14.5779L3.70091 2.73312L2.29909 3.26688ZM21.4993 6.81954C21.7629 6.0116 21.1608 5.1818 20.3109 5.1818V6.6818C20.1409 6.6818 20.0205 6.51584 20.0732 6.35425L21.4993 6.81954ZM17.5382 15.1C18.3594 14.9578 19.0346 14.3733 19.2931 13.581L17.8671 13.1157C17.7809 13.3798 17.5559 13.5746 17.2821 13.6221L17.5382 15.1ZM9.03997 15.05C8.68628 15.1113 8.33877 14.9133 8.21103 14.5779L6.80922 15.1117C7.19241 16.118 8.23497 16.7118 9.29603 16.528L9.03997 15.05Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cart.8eb3d6519ffc1bae9625fba7aaf7ab3c.svg";